import { CommonModelDiffRunExecution, ViewExecutionLogsHandler } from "../entities";
import { Alert, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { X } from "lucide-react";
import useAcknowledgeCommonModelDiffRun from "../hooks/useAcknowledgeCommonModelDiffRun";
import SubRunLogLinks from "./SubRunLogLinks";

interface FailedDiffAlertProps {
  diffRun: CommonModelDiffRunExecution;
  setCommonModelDiffRunExecutions: (diffRuns: CommonModelDiffRunExecution[]) => void;
  commonModelDiffRunExecutions: CommonModelDiffRunExecution[];
  onViewExecutionLogs?: ViewExecutionLogsHandler;
}

const FailedDiffAlert = ({
  diffRun,
  commonModelDiffRunExecutions,
  setCommonModelDiffRunExecutions,
  onViewExecutionLogs,
}: FailedDiffAlertProps) => {
  // const derived from state
  const title = `Execution failed for ${diffRun.linked_account_name} Linked Account with ID ${diffRun.linked_account_id}`;

  // hooks
  const { acknowledgeDiffRun } = useAcknowledgeCommonModelDiffRun({
    onSuccess: () => {
      const filteredRuns = commonModelDiffRunExecutions.filter((run) => run.id !== diffRun.id);
      setCommonModelDiffRunExecutions(filteredRuns);
    },
  });

  // handlers for hooks
  const handleAcknowledgeRun = () => {
    acknowledgeDiffRun(diffRun.id);
  };

  if (diffRun.is_acknowledged == true) {
    return null;
  }

  return (
    <Alert
      showWarningIcon
      title={
        <div className="flex items-center justify-between gap-2 w-full min-w-0">
          <Text className="font-semibold">{title}</Text>
          <Button
            onClick={handleAcknowledgeRun}
            size="sm"
            className="bg-red-0"
            variant={ButtonVariant.IconShadowHidden}
          >
            <X size={16} />
          </Button>
        </div>
      }
      color="red"
    >
      <div className="whitespace-pre-wrap break-words break-all max-w-full">
        {diffRun.exception_message}
      </div>
      <SubRunLogLinks diffRun={diffRun} onViewExecutionLogs={onViewExecutionLogs} />
    </Alert>
  );
};

export default FailedDiffAlert;
